import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface NewYearFDConfig {
  isVisiblenewYearFD: boolean;
  maxYearFiscalDraft: number;
}

export const newYearFDConfig: NewYearFDConfig = {
  isVisiblenewYearFD: environment.isVisibleNewYearFiscalDraft,
  maxYearFiscalDraft: environment.maxYearFiscalDraft,
};

export const NEW_YEAR_FD = new InjectionToken<NewYearFDConfig>('newYearFD');
